import React from 'react'
import {Container, Dialog, DialogActions, DialogContent, Divider, Grid, TextField} from "@mui/material";
import {Formik, useFormikContext} from "formik";
import * as Yup from "yup";
import {InputNumerico} from "../inputs/InputNumerico";
import {Madeira} from "../../types/Madeira";
import { PaperArrastavel } from "../dialog-arrastavel/PaperArrastavel";
const estiloTratamentoMadeira =
  require("./Tratamento-madeira.module.scss").default;
const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default


export type TratamentoMadeiraProps = {
    open: boolean
    somenteLeitura: boolean
    handleClose: () => void
    onOk: (dados: Madeira) => void
    initialValues: Madeira
    numeroCasasDecimais: number
}

export const TratamentoMadeira = (props: TratamentoMadeiraProps) => {
    const schema = Yup.object().shape({
        unidadeVenda: Yup.string().required('Unidade Venda Obrigatória'),
        largura: Yup.number().min(0, "Largura deve ser maior que 0"),
        altura: Yup.number().min(0, "Altura deve ser maior que 0"),
        espessura: Yup.number().min(0, "Espessura deve ser maior que 0"),
        comprimento: Yup.number().min(0, "Comprimento deve ser maior que 0"),
        qtdSolicitada: Yup.number().min(0, "Quantidade Solicitada deve ser maior que 0")
    });

    const calcularValorTotalM = (values) => {
        return values?.unidadeVenda == 'M3' ? values?.largura*values?.altura*values?.espessura*values?.qtdSolicitada :
            values?.unidadeVenda == 'M2' ? values?.largura*values?.altura*values?.qtdSolicitada :
            values?.unidadeVenda == 'ML' ? values?.comprimento*values?.qtdSolicitada :
            values?.unidadeVenda == 'PC' || values?.unidadeVenda == 'UN'  ? values?.qtdSolicitada :
            0
    } 

    const calcularValorTotal = (values) => {
        const precoVenda = values?.precoVenda === 1 ? values?.precoVenda1 :
                        values?.precoVenda === 2 ? values?.precoVenda2 :
                        values?.precoVenda === 3 ? values?.precoVenda3 :
                        0
        if (values == 0)
            values = 1; // 449990
        return calcularValorTotalM(values)*precoVenda
    } 
    
    return <Dialog
        open={props.open}
        fullWidth
        maxWidth="md"
        id="TratamentoMadeiraDialog"
        onClose={props.handleClose}
        PaperComponent={PaperArrastavel}
    >
        <DialogContent
            style={{ padding: "15px", backgroundColor: 'var(--mu-superficie-sutil, #F2F2F2)' }}
        >
            <Formik
                initialValues={props.initialValues}
                enableReinitialize
                validationSchema={schema}
                id="TratamentoMadeiraFormKit"
                onSubmit={props.onOk}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                      setFieldTouched,
                      validateForm
                  }) => (
                    <form onSubmit={handleSubmit}>
                        
                        <h2>Produto</h2>
                        <fieldset>
                            <div className={estiloTratamentoMadeira.form} >
                                <label>Código</label>
                                <input
                                    value={(values?.codigo) ?? ""}
                                    className={estilosInputs.input100PorCento}
                                        onChange={handleChange('codigo')}
                                        type="text"
                                        readOnly disabled />
                            </div>

                            <div className={estiloTratamentoMadeira.form}>
                                <label>Descrição</label>
                                <input
                                    value={(values?.descricao) ?? ""}
                                    style={{width: '630px'}}
                                    onChange={handleChange('descricao')}
                                    type="text"
                                    readOnly disabled />
                            </div>

                            <div className={estiloTratamentoMadeira.form}>
                                <label>Quantidade</label>
                                <InputNumerico
                                    onValorModificado={(valorModificado) =>
                                        setFieldValue('quantidade', valorModificado)
                                    }
                                    valor={values?.quantidade}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />

                                <span>Reservada</span>
                                <InputNumerico
                                    onValorModificado={(valorModificado) =>
                                        setFieldValue('qtdReservada', valorModificado)
                                    }
                                    valor={values?.qtdReservada}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />

                                <span>Disponível</span>
                                <InputNumerico
                                    onValorModificado={(valorModificado) =>
                                        setFieldValue('qtdDisponivel', valorModificado)
                                    }
                                    valor={values?.qtdDisponivel}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />
                            </div>
                        </fieldset>
                        
                        <h2>Madeira</h2>
                        <fieldset>
                            <div className={estiloTratamentoMadeira.fieldMadeira} >
                                    <label>Unidade Venda</label>
                                    <input
                                        onChange={handleChange('unidadeVenda')}
                                        value={(values?.unidadeVenda) ?? ""}
                                        type="text"
                                        readOnly disabled/>
                            </div>
                            <div className={estiloTratamentoMadeira.fieldMadeira} >
                                <label>Largura</label>
                                <InputNumerico
                                    numeroCasasDecimais={props.numeroCasasDecimais}
                                    onValorModificado={(valorModificado) => {
                                        setFieldValue('largura', valorModificado, true)
                                        setTimeout(() => setFieldTouched('largura', true))
                                        setFieldValue('totalM', calcularValorTotalM({...values, largura: valorModificado}))
                                        setFieldValue('total', calcularValorTotal({...values, largura: valorModificado}))
                                    }}
                                    valor={values?.largura}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled={props.somenteLeitura || (values?.unidadeVenda != 'M3' && values?.unidadeVenda != 'M2')}
                                    pattern='' // 477329
                                />

                                <span>Altura</span>
                                <InputNumerico
                                    numeroCasasDecimais={props.numeroCasasDecimais}
                                    id="TratamentoMadeiraAltura"
                                    onValorModificado={(valorModificado) => {
                                        setFieldValue('altura', valorModificado)
                                        setTimeout(() => setFieldTouched('altura', true))
                                        setFieldValue('totalM', calcularValorTotalM({...values, altura: valorModificado}))
                                        setFieldValue('total', calcularValorTotal({...values, altura: valorModificado}))
                                    }}
                                    valor={values?.altura}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled={props.somenteLeitura || (values?.unidadeVenda != 'M3' && values?.unidadeVenda != 'M2')}
                                    pattern='' // 477329
                                />
                                
                                <span>Espessura</span>
                                <InputNumerico
                                    numeroCasasDecimais={props.numeroCasasDecimais}
                                    id="TratamentoMadeiraEspessura"
                                    onValorModificado={(valorModificado) => {
                                        setFieldValue('espessura', valorModificado)
                                        setTimeout(() => setFieldTouched('espessura', true))
                                        setFieldValue('totalM', calcularValorTotalM({...values, espessura: valorModificado}))
                                        setFieldValue('total', calcularValorTotal({...values, espessura: valorModificado}))
                                    }}
                                    valor={values?.espessura}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled={props.somenteLeitura || ( values?.unidadeVenda != 'M3') }
                                    pattern='' // 477329
                                />
                            </div>

                            <div className={estiloTratamentoMadeira.fieldMadeira} >
                                <label>Comprimento</label>
                                <InputNumerico
                                    numeroCasasDecimais={props.numeroCasasDecimais}
                                    id="TratamentoMadeiraComprimento"
                                    onValorModificado={(valorModificado) => {
                                        setFieldValue('comprimento', valorModificado)
                                        setTimeout(() => setFieldTouched('comprimento', true))
                                        setFieldValue('totalM', calcularValorTotalM({...values, comprimento: valorModificado}))
                                        setFieldValue('total', calcularValorTotal({...values, comprimento: valorModificado}))
                                    }}
                                    valor={values?.comprimento}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled={props.somenteLeitura || values?.unidadeVenda != 'ML'}
                                    pattern='' // 477329
                                />
                            </div>
                            <div className={estiloTratamentoMadeira.fieldMadeira} >
                                <label>Quantidade Solicitada</label>
                                <InputNumerico
                                    numeroCasasDecimais={2}
                                    pattern='' // 477329
                                    id="TratamentoMadeiraQtdSolicitada"
                                    onValorModificado={(valorModificado) => {
                                        setFieldValue('qtdSolicitada', valorModificado)
                                        setTimeout(() => setFieldTouched('qtdSolicitada', true))
                                        setFieldValue('totalM', calcularValorTotalM({...values, qtdSolicitada: valorModificado}))
                                        setFieldValue('total', calcularValorTotal({...values, qtdSolicitada: valorModificado}))
                                    }}
                                    valor={values?.qtdSolicitada}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled={props.somenteLeitura}
                                />
                            
                                <span>Total {values?.unidadeVenda}</span>
                                <InputNumerico
                                    pattern='' // 477329
                                    id="TratamentoMadeiraTotal"
                                    numeroCasasDecimais={3}
                                    valor={values?.totalM}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />
                            </div>
                        </fieldset>
                        <ul className={estiloTratamentoMadeira.listaErros}>
                            <li>{errors.unidadeVenda}</li>
                            <li>{errors.largura?.length > 0 && touched.largura && errors.largura }</li>
                            <li>{errors.altura?.length > 0 && touched.altura && errors.altura }</li>
                            <li>{errors.espessura?.length > 0 && touched.espessura && errors.espessura }</li>
                            <li>{errors.comprimento?.length > 0 && touched.comprimento && errors.comprimento }</li>
                            <li>{errors.qtdSolicitada?.length > 0 && touched.qtdSolicitada && errors.qtdSolicitada }</li>
                        </ul>

                        <h2>Preço de venda</h2>
                        <fieldset>
                            <div className={estiloTratamentoMadeira.fieldPrecoVenda} >
                                <label>
                                    <input
                                        type="radio"
                                        value="1"
                                        name="precoVenda"
                                        checked={values?.precoVenda === 1}
                                        onClick={() => { 
                                            setFieldValue('precoVenda', 1)
                                            setFieldValue('total', calcularValorTotal({...values, precoVenda: 1}))
                                        }}
                                        disabled={props.somenteLeitura}
                                    />
                                    Preço Venda 1
                                </label>
                                <InputNumerico
                                    numeroCasasDecimais={4}
                                    valor={values?.precoVenda1}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />
                            </div>
                            <div className={estiloTratamentoMadeira.fieldPrecoVenda} >
                            
                                <label>
                                    <input
                                        type="radio"
                                        value="2"
                                        checked={values?.precoVenda === 2}
                                        name="precoVenda"
                                        onClick={() => {
                                            setFieldValue('precoVenda', 2)
                                            setFieldValue('total', calcularValorTotal({...values, precoVenda: 2}))
                                        }}
                                        disabled={props.somenteLeitura}
                                    />
                                    Preço Venda 2
                                </label>
                                <InputNumerico
                                    numeroCasasDecimais={4}
                                    valor={values?.precoVenda2}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />
                            
                            </div>
                            <div className={estiloTratamentoMadeira.fieldPrecoVenda} >
                            
                                <label>
                                    <input
                                        type="radio"
                                        value="3"
                                        checked={values?.precoVenda === 3}
                                        name="precoVenda"
                                        onClick={() => {
                                            setFieldValue('precoVenda', 3)
                                            setFieldValue('total', calcularValorTotal({...values, precoVenda: 3}))
                                        }}
                                        disabled={props.somenteLeitura}
                                    />
                                    Preço Venda 3
                                </label>
                                <InputNumerico
                                    numeroCasasDecimais={4}
                                    valor={values?.precoVenda3}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />


                                <label>
                                    Total:
                                </label>
                                <InputNumerico
                                    numeroCasasDecimais={2}
                                    valor={values?.total}
                                    classesInput={[estilosInputs.input100PorCento]}
                                    disabled
                                />
                            </div>
                            
                        </fieldset>
                        <DialogActions style={{ padding: "15px" }}>
                        {!props.somenteLeitura &&
                            <button
                                id="TratarMadeiraOk"
                                type="submit"
                                className={estilosBotoes.botaoPrimario}
                            >
                                Ok
                            </button>
                            }
                            <button
                                id="TratarMadeiraCancelar"
                                onClick={props.handleClose}
                            >
                                {!props.somenteLeitura && 'Cancelar'}
                                {props.somenteLeitura && 'Fechar'}
                            </button>
                        </DialogActions>
                    </form>)}
            </Formik>
        </DialogContent>
    </Dialog>
}
